<template>
  <div>
    <Nav :showMobileSearch="false" ref="Nav" />
    <div class="special-box">
      <div class="main-box">
        <div class="special-banner">
          <img
            :src="
              collectionsDetails.img
                ? 'https://img.library.sh.cn/whzk/img/' + collectionsDetails.img
                : banner
            "
            alt=""
          />
          <div class="name">
            <span>{{ collectionsDetails.title }}</span>
          </div>
        </div>
        <div class="special-des">
          <span>专题介绍</span>
          <div class="des" v-if="collectionsDetails.description">
            {{ collectionsDetails.description }}
          </div>
        </div>
         <!-- <div style="cursor:pointer;float:right;position:absolute;;margin-left: 70%;color:#EB7575" @click="handleFullScreen">【全屏】</div> -->
        <div class="special-relation" id="mountNode"></div>
       
        <div class="result-count">
          <span
            >唱片<b>{{ recordCount }}</b
            >种</span
          >
          <div class="sort">
                <span :class="sorts[0] ? 'cur' : ''" @click="onSorts(0)"
                  >题名</span
                >
                <span :class="sorts[1] ? 'cur' : ''" @click="onSorts(1)"
                  >出版时间</span
                >
                <span :class="sorts[2] ? 'cur' : ''" @click="onSorts(2)"
                  >责任者</span
                >
                <span
                  :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                  @click="onlyCanPlay"
                  >可播放唱片</span
                >
              </div>
        </div>
     <div class="record-list" v-if="recordList && recordList.length > 0">
          <div
            v-for="(item, index) in recordList"
            :key="'recordList' + index"
            class="record-cell"
          >
               <div class="pic" >
                    <router-link :to="'/rec-info/'+encodeURIComponent(item['@id'])" v-if="item.title"> 
                  <img
                    v-if="item.cover[0]"
                    :src="
                      'https://img.library.sh.cn/hisdata/cp/img/' +
                      item.cover[0]
                    "
                    alt=""
                  />
                  <img v-else :src="baseRecordPic" alt="" />
                  </router-link>
                    <div v-if="item.playable" class="h-box" @click="playSong(item, index)">
                    </div>
                </div>
            <router-link
              :to="'/rec-info/' + encodeURIComponent(item['@id'])"
              class="tit"
              v-if="item.dcTitle"
            >
              {{ item.dcTitle["@value"].replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'')}}
            </router-link>
            <div class="info" v-if="item.creator">{{ item.creator }}</div>
            <div v-if="!isMobile && item.date" class="info">{{ item.date }}</div>
          </div>
          <div class="clear-f"></div>
        </div>
        <div class="page-box">
          <a-pagination
            :total="pagerCount"
            :current="currentPage"
            @change="onChange"
            show-quick-jumper
            show-less-items
          />
        </div>
      </div>
    </div>
    <Footer />
    <Player ref="player" />
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Player from "@/components/player";
import Footer from "@/components/footer";
import { baseRecordPic } from "@/util/basePic";
import Graph from "@antv/g6";
import {
  phonorecordCollectionsGet,
   phonorecordSearchGet,
  collectionRelations,
} from "@/api";

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);
export default {
  components: {
    Nav,
    Player,
    Footer,
  },
  data() {
    return {
      fullScreen:false,
      isMobile,
      queryUri: decodeURIComponent(this.$route.params.id),
      paramByCollection: {
       // 唱片检索参数
        field: "ISPARTOF",
        value: "",
        sort: "TI",
        order: 1,
        PLAY: '',//是否可播放，默认全部查询 chenss
        pageth: 1,
        pageSize: 10,
      },
      baseRecordPic,
      hasAudio: false, //是否可播放标记 chenss
      onlyShowPlay: false, //是否可播放标记 chenss
      banner: require("./../../../public/img/demo/banner.png"),
      rootNodeFlag: false, // 根节点 点击[隐藏/显示] 控制
      g6Graph: null, // 实例化
      g6GraphData: {
        // 数据
        nodes: [],
        edges: [],
      },
      g6Tooltip: null, // 自定义提示插件
      g6GraphLayout: {
        // 布局
        type: "force", // force:经典的力导向布局
        preventOverlap: true, // 是否防止重叠
        collideStrength: 1, // 防止重叠的力强度，范围 [0, 1]
        linkDistance: (d) => {
          // 边长度
          if (d.source.id === this.rootNodeId) {
            return isMobile ? 10 : 100;
          }
          return isMobile ? 10 : 80;
        },
        nodeStrength: (d) => {
          // 节点作用力，正数代表节点之间的引力作用，负数代表节点之间的斥力作用
          if (d.isLeaf) {
            return isMobile ? -10 : -30;
          }
          return -10;
        },
        nodeSpacing: (d) => { // 设置最小间距
          if (d.isLeaf) {
            return isMobile ? 1 : 6;
          }
          return 10;
        },
        edgeStrength: (d) => {
          // 边的作用力，默认根据节点的出入度自适应
          if (this.edgeStrengthList.indexOf(d.source.id) != -1) {
            return isMobile ? 2 : 0.7;
          }
          return 0.1;
        },
      },
      sorts: [true, false, false],
      collectionsDetails: {},
      relationsData: {},
      pagerCount: 1,
      currentPage: 1, // 当前页码
      recordCount: 0,
      recordList: [],
      edgeStrengthList: [], // 节点ID储存
      rootNodeId: "node0", // 根节点ID
      nodeType: [
        {
          type: "phonorecord",
          name: "唱片",
          units: "种",
          url: "/rec-info/",
        },
        { type: "person", name: "乐人", units: "人", url: "/musician-detail/" },
        {
          type: "organization",
          name: "机构团体",
          units: "个",
          url: "/company-detail/",
        },
        { type: "music", name: "曲目", units: "", url: "/song-detail/" },
      ],
      nodeTypeUriArray: [ // 判断节点是否可跳转（URI带CP的都无法跳转）
        'organization', 
        'person'
      ],
    };
  },
  computed: {
    paramsUrl: (res) => {
      return res.$route.params.id;
    },
    rootNodeData() {
      // 根节点
      const IMG_URI = this.collectionsDetails.img
        ? "https://img.library.sh.cn/whzk/img/" + this.collectionsDetails.img
        : this.banner;
      return {
        id: this.rootNodeId,
        type: "circular-image",
        label: this.collectionsDetails.title,
        isLeaf: false,
        size: isMobile ? 40 : 90,
        img: IMG_URI,
        style: {
          width: isMobile ? 40 : 90,
          lineWidth: 2,
          shadowOffsetX: 2,
        },
        clipCfg: {
          // 裁剪图片配置
          show: true,
          type: "circle",
          r: isMobile ? 20 : 45,
          x: 0,
          y: 0,
        },
        labelCfg: {
          position: "bottom",
          offset: 10,
          style: {
            fill: "#000",
            textAlign: "center",
            r: isMobile ? 20 : 45,
            // x: -50,
            y: isMobile ? 36 : 60,
            lineWidth: 2,
            shadowOffsetX: 2,
          },
        },
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      if(this.GLOBAL.BASE_IP_INFO.ipIsInner){//如果是内网，直接勾选可播放按钮 chenss 20220831
        this.onlyCanPlay();
      }
      else{
        this.phonorecordCollectionsGet();
      }
    });
  },
  methods: {
    handleFullScreen:function(){
                this.fullScreen = !this.fullScreen;
                var element = document.getElementById("mountNode");
                if (this.fullScreen) {//全屏
                        if (element.requestFullscreen) {
                            element.requestFullscreen();
                        } else if (element.mozRequestFullScreen) {
                            element.mozRequestFullScreen();
                        } else if (element.webkitRequestFullScreen) {
                            element.webkitRequestFullScreen();
                        } else if (element.msRequestFullscreen) {
                            element.msRequestFullscreen();
                        }
                        else {
                            wtx.info("当前浏览器不支持部分全屏！");
                        }
                    return false;
                } else {//退出全屏
                   //console.log('exitFullscreen',element)
                      if(document.exitFullscreen) {
                          document.exitFullscreen();
                      } else if(document.mozCancelFullScreen) {
                          document.mozCancelFullScreen();
                      } else if(document.webkitExitFullscreen) {
                          document.webkitExitFullscreen();
                      } else if(document.msExitFullscreen) {
                          document.msExitFullscreen();
                      }
              
                }

            },
    onlyCanPlay() {
      // 仅显示可播放唱片
      this.onlyShowPlay = !this.onlyShowPlay;
      this.hasAudio = this.onlyShowPlay;
      //console.log(this.hasAudio);
      this.paramByCollection.PLAY = "";
      if (this.hasAudio) {
        this.paramByCollection.PLAY = "1";
      }
      this.phonorecordCollectionsGet();
    },
    async phonorecordCollectionsGet() {
      // 专题详情
      const res = await phonorecordCollectionsGet({ uri: this.queryUri });
      const data = res.data;
      // //console.log(data);
      this.collectionsDetails = data.datas[0];
      this.phonorecordByCollection();
      this.collectionRelations();
    },
    async phonorecordByCollection() {
      // 唱片列表
      this.paramByCollection.value = this.queryUri;
      this.paramByCollection.pageth = this.currentPage;
      // 排序
      this.paramByCollection.sort = "";
      if (this.sorts[0]) this.paramByCollection.sort = "TI";
      if (this.sorts[1]) this.paramByCollection.sort = "TIME";
      if (this.sorts[2]) this.paramByCollection.sort = "CO";
      //查询唱片列表
      const res = await phonorecordSearchGet(this.paramByCollection);
      const data = res.data;
      // //console.log(data);
      this.recordList = data.datas;
      this.recordCount = data.pager.rowCount;
      this.pagerCount = data.pager.rowCount;
    },
    async collectionRelations() {
      // 关系图表
      const res = await collectionRelations({ collection: this.queryUri });
      const data = res.data;
      this.g6GraphDataHandle(data.datas);
    },
    g6GraphDataHandle(datas) {
      // 连接线维护判断
      let edgesFlag = true;
      // 节点
      const nodes = datas.nodes;
      // 连接线
      const edges = datas.edges;
      this.nodeType.forEach((ntItem, ntIndex) => {
        const nodeTypeName = ntItem.name;
        const nodeTypeType = ntItem.type;
        const nodeTypeUnits = ntItem.units;
        nodes.forEach((item, index) => {
          // 节点数据调整
          let nodeId = item.id;
          let nodeName = item.name;
          let nodeCount = item.name1;
          // 二级节点调整
          if (nodeId == nodeName && nodeId.indexOf(nodeTypeName) !== -1) {
            if(isMobile && nodeName=='机构团体'){
              nodeName='机构';
            }
            item.label = nodeName + "\n" + nodeCount + nodeTypeUnits;
            item.size = isMobile ? 40 : 60;
            item.isLeaf = true;
            item.style = {
              fill: "#cb5554",
              color: "#fff",
            };
            item.labelCfg = {
              style: {
                fill: "#fff", // 二级节点字体颜色
                cursor: "pointer",
              },
            };
          }
          if (
            nodeId.indexOf("http") == 0 &&
            nodeId.indexOf(nodeTypeType) != -1
          ) {
            // 三级节点调整
            nodeName = nodeName.length > 5 ? nodeName.slice(0, 3) + "..." : nodeName;
            item.label = nodeName;
            item.size = isMobile ? 40 : 60;
            item.isLeaf = true;
            item.style = {
              width: 150,
              fill: "#DA984A", // 三级节点外边框颜色
              stroke: "#DA984A", // 三级节点背景色
            };
            item.labelCfg = {
              style: {
                fill: "#fff", // 三级节点字体颜色
                cursor: this.nodeTypeUriArray.indexOf(nodeTypeType) != -1 && nodeId.indexOf("/cp/") > 0 ? "default":"pointer", // 三级节点鼠标样式改变
              },
            };
          }
        });
        try {
          edges.forEach((item, index) => {
            // 节点关系调整
            let edgeSource = item.source;
            let edgeTarget = item.target;
            if (
              edgeSource.indexOf("http") === 0 &&
              edgeTarget.indexOf(nodeTypeName) !== -1
            ) {
              this.edgeStrengthList.push(edgeSource);
              if (edgesFlag) {
                // 重置根节点ID`
                this.rootNodeId = edgeSource;
                edgesFlag = false;
                // 跳出循环
                // throw new Error("breakForEach");
              }
            }
          });
        } catch (e) {
          if (e.message != "breakForEach") throw e;
        }
      });
      // 加入根节点
      datas.nodes.push(this.rootNodeData);
      this.g6GraphData = datas;
      // 自定义tooltip
      this.g6TooltipHandle();
      // 自定义节点初始化
      this.g6RegisterNode();
      this.registerNodeRoundRect();
      setTimeout(() => {
        // G6初始化
        this.g6GraphInit();
      }, 200);
    },
    graphHideItem() {
      // 默认隐藏三级节点
      const graphNodes = this.g6Graph.getNodes();
      graphNodes.forEach((gn) => {
        const gnModel = gn.getModel();
        const gnNodeId = gnModel.id;
        const gnNodeType = gnModel.type;
        this.nodeType.forEach((ntItem, ntIndex) => {
          const nodeTypeType = ntItem.type;
          if (
            gnNodeId != this.rootNodeId &&
            gnNodeId.indexOf(nodeTypeType) != -1 &&
            gnNodeType == 3
          ) {
            this.g6Graph.hideItem(gnNodeId);
          }
        });
      });
    },
    onSorts(n) {
      // 排序
      this.sorts.splice(n, 1, !this.sorts[n]);
      let allFalse = 1;
      this.sorts.forEach((item, index) => {
        if (n != index) {
          this.sorts[index] = false;
        }
        if (item == true) {
          allFalse = 2;
        }
      });
      if (allFalse == 1) {
        this.sorts[0] = true;
      }
      this.phonorecordByCollection();
    },
    onChange(current) {
      // 页码点击
      this.currentPage = current;
      this.phonorecordByCollection();
    },
    registerNodeRoundRect() {
      // 节点定义
      const _this = this;
      // 定义节点
      _this.$G6.registerNode(
        "round-rect",
        {
          drawShape: function drawShape(cfg, group) {
            const width = cfg.style.width;
            const stroke = cfg.style.stroke;
            const rect = group.addShape("rect", {
              attrs: {
                x: -width / 2,
                y: -15,
                width: width,
                height: 30,
                radius: 15,
                fill: cfg.style.fill,
                stroke: stroke,
                lineWidth: cfg.style.lineWidth,
                fillOpacity: cfg.style.fillOpacity || 0,
              },
              name: "rect-shape",
            });
            group.addShape("circle", {
              attrs: {
                x: -width / 2,
                y: 0,
                r: 3,
                fill: stroke,
              },
              name: "circle-shape",
            });
            group.addShape("circle", {
              attrs: {
                x: width / 2,
                y: 0,
                r: 3,
                fill: stroke,
              },
              name: "circle-shape2",
            });
            return rect;
          },
          // getAnchorPoints: function getAnchorPoints() {
          //   return [
          //     [0, 0.5],
          //     [1, 0.5],
          //   ];
          // },
          update: function update(cfg, item) {
            const group = item.getContainer();
            const children = group.get("children");
            const node = children[0];
            const circleLeft = children[1];
            const circleRight = children[2];

            const stroke = cfg.style.stroke;

            if (stroke) {
              node.attr("stroke", stroke);
              circleLeft.attr("fill", stroke);
              circleRight.attr("fill", stroke);
            }
          },
        },
        "single-node"
      );
    },
    g6RegisterNode() {
      // 自定义节点
      const _this = this;
      _this.$G6.registerNode(
        "circular-image",
        {
          draw(cfg, group) {
            // 如果 cfg 中定义了 style 需要同这里的属性进行融合
            const keyShape = group.addShape("circle", {
              attrs: {
                x: cfg.style.x || 0,
                y: cfg.style.y || 0,
                r: cfg.style.radius || cfg.clipCfg.r || 80,
                lineWidth: cfg.style.lineWidth,
                fill: cfg.style.fill,
                stroke: cfg.style.stroke,
                fillOpacity: cfg.style.fillOpacity || 0,
              },
              name: "circle-image-shape",
              draggable: true,
            });
            // 如果有图片，则传入图片
            if (_this.relationshipGraphImage || cfg.img || cfg.style.img) {
              // 节点内置图片
              group.addShape("image", {
                attrs: {
                  x: -cfg.size || 0,
                  y: -cfg.size / 2 || 0,
                  // width: cfg.size,
                  height: cfg.size,
                  img: _this.relationshipGraphImage || cfg.img || cfg.style.img,
                },
                zIndex: 0,
                name: "my-image-shape",
                capture: true,
                // 设置 draggable 以允许响应鼠标的图拽事件
                draggable: true,
              });
              // 裁剪图片
              const shape = group.get("children")[1];
              shape.setClip({
                type: "circle", // 支持 circle、rect、ellipse、Polygon 及自定义 path clip
                attrs: cfg.clipCfg,
              });
            }
            // 如果有文本
            if (cfg.label) {
              // 如果需要复杂的文本配置项，可以通过 labeCfg 传入
              const style = (cfg.labelCfg && cfg.labelCfg.style) || {};
              style.text = cfg.label;
              group.addShape("text", {
                x: 100,
                y: 10000,
                textAlign: "left",
                // attrs: style
                attrs: style,
                name: "my-text-shape",
                // 设置 draggable 以允许响应鼠标的图拽事件
                draggable: true,
              });
            }
            return keyShape;
          },
        },
        "circle"
      );
    },
    g6TooltipHandle() { // 鼠标悬停提示
      this.g6Tooltip = new this.$G6.Tooltip({
        offsetX: 10,
        offsetY: 20,
        shouldBegin(e) { // 提示框是否显示
          const model = e.item.getModel();
          if(model.type && model.type != 3) return false;
          if(model.name && model.name.length <= 5) return false;
          return true;
        },
        getContent(e) { // 提示框显示内容
          const model = e.item.getModel();
          const outDiv = document.createElement('div');
          outDiv.style.width = 'fit-content';
          // outDiv.style.height = '18px';
          outDiv.innerHTML = `
            <!-- <h4>自定义tooltip</h4> -->
            <ul">
              <li>${model.name.replace('~','').replace('=','').replace(':','').replace(/[||]/g,'#').replace(/##/g,'') || ""}</li>
            </ul>`;
          return outDiv;
        },
        itemTypes: ['node']
      });
    },
    g6GraphInit() {
      // 初始化 g6
      const mountNode = document.getElementById("mountNode");
      const width = mountNode.scrollWidth || 0;
      const height = mountNode.scrollHeight || 422;
      this.g6Graph = new this.$G6.Graph({
        container: "mountNode",
        width,
        height,
        // fitView: true, // 超出画布自适应
        // fitViewPadding: [10, 10, 10, 10],
        animate: true, // Boolean，切换布局时是否使用动画过度，默认为 false
        layout: this.g6GraphLayout, // 布局
        plugins: [this.g6Tooltip], // 配置 Tooltip 插件
        defaultEdge: {
          // 线配置
          style: {
            stroke: "#ccc",
            lineWidth: 2,
          },
        },
        defaultNode: {
          // 节点配置
          // type: 'image',
          // color: '#ebe9da',
          style: {
            fill: "#F2994A",
            fontSize: "10px",
            stroke: "#fff",
            lineWidth: 2,
            cursor: "default",
          },
          labelCfg: {
            // 文字配置
            style: {
              fill: "#000",
              fontFamily: "SourceHanSansCN-Medium",
            },
          },
        },
        modes: {
          default: [
            {
              type: "drag-node",
            },
          ],
        },
      });
      this.g6Graph.findAll("node", (node) => !node.hasLocked());
      this.onGraphFun(mountNode);
      // 更改所有子节点层级
      this.toFrontHandle();
      // 隐藏三级节点
      this.graphHideItem();
    },
    toFrontHandle() {
      // 更改所有子节点层级
      // 数据
      const nodes = this.g6Graph.getNodes();
      nodes.forEach((gn) => {
        const gnModel = gn.getModel();
        const gnNodeId = gnModel.id;
        if (gnNodeId !== this.rootNodeId) {
          gn.toFront();
        }
      });
      // 更改层级后需要重新绘制图
      this.g6Graph.paint();
    },
    onGraphFun(el) {
      // 数据
      const nodes = this.g6GraphData.nodes;
      this.g6Graph.data({
        nodes,
        edges: this.g6GraphData.edges.map((edge, i) => {
          edge.id = "edge" + i;
          return Object.assign({}, edge);
        }),
      });
      // 根据提供的数据渲染视图
      this.g6Graph.render();
      // this.g6Graph.refresh()

      // this.g6Graph.on('node:mouseenter', (evt) => {
      //   const { item } = evt
      //   this.g6Graph.setItemState(item, 'hover', true)
      // })
      // this.g6Graph.on('node:mouseleave', (evt) => {
      //   const { item } = evt
      //   this.g6Graph.setItemState(item, 'hover', false)
      // })
      // 点击次数
      let dblclickCount = 0;
      this.g6Graph.on("node:dblclick", (evt) => {
        // 双击
        const targetItem = evt.item;
        const model = targetItem.getModel();
        dblclickCount++;
        if (dblclickCount == 2) {
          dblclickCount = 0;
          return;
        }
        this.nodeRouterHandle(model);
      });

      this.g6Graph.on("node:click", (evt) => {
        // 单击
        this.onG6ClickEvent(evt);
      });

      var myTimeout = null;
      this.g6Graph.on("node:touchmove", (evt) => {
        // 当节点开始被触碰过程中触发
        clearTimeout(myTimeout);
      });
      this.g6Graph.on("node:touchstart", (evt) => {
        // 当节点开始被触碰的时候触发
        myTimeout = setTimeout(() => {
          this.onG6ClickEvent(evt);
        }, 360);
      });
      this.g6Graph.on("node:touchend", (evt) => {
        // 当节点开始被触碰结束的时候触发
        // this.onG6ClickEvent(evt);
      });
      this.g6Graph.on("node:dragstart", (e) => {
        this.g6Graph.layout();
        this.refreshDragedNodePosition(e);
      });
      
      this.g6Graph.on("node:drag", (e) => {
        this.refreshDragedNodePosition(e);
      });
      this.g6Graph.on("node:dragend", (e) => {
        e.item.get("model").fx = null;
        e.item.get("model").fy = null;
        e.item.get("model").fy = null;
      });

      if (typeof window !== "undefined") {
        window.onresize = () => {
          if (!this.g6Graph || this.g6Graph.get("destroyed")) return;
          if (!el || !el.scrollWidth || !el.scrollHeight) return;
          this.g6Graph.changeSize(el.scrollWidth, el.scrollHeight);
        };
      }
    },
    onG6ClickEvent(evt){
      const node = evt.item;
      const model = node.getModel();
      const nodeId = model.id;
      const graphEdges = this.g6Graph.getEdges();
      const graphNodes = this.g6Graph.getNodes();
      // 页面跳转
      this.nodeRouterHandle(model);
      // 节点 隐藏/显示
      graphNodes.forEach((gn) => {
        const gnModel = gn.getModel();
        const gnNodeId = gnModel.id;
        this.nodeType.forEach((ntItem, ntIndex) => {
          const nodeTypeName = ntItem.name;
          const nodeTypeType = ntItem.type;
          // 三级节点 隐藏/显示
          if (
            nodeId != gnNodeId &&
            nodeId == nodeTypeName &&
            gnNodeId.indexOf(nodeTypeType) != -1
          ) {
            if (gn.isVisible()) gn.hide();
            else gn.show();
          }
        });
        // 根节点下所有节点 隐藏/显示
        if (nodeId == this.rootNodeId && nodeId != gnNodeId) {
          if (this.rootNodeFlag) {
            gn.show();
          } else gn.hide();
        }
      });
      // 节点连接线 隐藏/显示
      graphEdges.forEach((ge) => {
        const geModel = ge.getModel();
        const geSource = geModel.source;
        const geTarget = geModel.target;
        this.nodeType.forEach((ntItem, ntIndex) => {
          const nodeTypeName = ntItem.name;
          const nodeTypeType = ntItem.type;
          // 三级节点连接线 隐藏/显示
          if (
            nodeId == nodeTypeName &&
            geTarget.indexOf(nodeTypeType) != -1
          ) {
            if (ge.isVisible()) ge.hide();
            else ge.show();
          }
        });
        // 根节点下所有节点 隐藏/显示
        if (nodeId == this.rootNodeId) {
          if (this.rootNodeFlag) ge.show();
          else ge.hide();
        }
      });
      // 根节点点击 显示/隐藏 控制
      if (nodeId == this.rootNodeId) this.rootNodeFlag = !this.rootNodeFlag;
      // 刷新
      this.g6Graph.layout(true);
      // this.g6Graph.paint();
      // //console.log('node:click');
    },
    nodeRouterHandle(model) {
      // 页面跳转
      const uri = model.id;
      if (uri.indexOf("http:") != -1 && model.type == 3) {
        try {
          this.nodeType.forEach((ntItem, ntIndex) => {
            const nodeTypeType = ntItem.type;
            const nodeTypeUrl = ntItem.url;
            if (uri.indexOf(nodeTypeType) != -1) {
              if (this.nodeTypeUriArray.indexOf(nodeTypeType) != -1 && uri.indexOf("/cp/") > 0) {
                //如果不是唱片资源本身，则允许跳转，因为乐人数据未全部生成索引数据
                this.$router.push(null);
              } else {
                this.$router.push(nodeTypeUrl + encodeURIComponent(uri));
              }

              // 跳出循环
              throw new Error("breakForEach");
            }
          });
        } catch (e) {
          if (e.message != "breakForEach") throw e;
        }
      }
    },
    refreshDragedNodePosition(e) {
      const model = e.item.get("model");
      model.fx = e.x;
      model.fy = e.y;
    },
    reRender() {
      // 重新渲染
      const Util = Graph.Util;
      this.g6Graph.clear();
      // this.g6Graph.read(Util.clone(this.g6GraphData));
      this.g6Graph.render();
    },
    async playSong(item, index) {
      // console.log(item)
      // this.curIndex = index;
      this.$refs.player.playSong(this.$refs.Nav, item);
    },
  },
};
</script>
